import { MutableRefObject, useEffect } from 'react';
import type { GridApi } from 'ag-grid-community';

interface Options {
  clearRange?: boolean;
  clearFocus?: boolean;
  clearRows?: boolean;
  containerSelector?: string; // CSS selector for container to treat as inside clicks
}

// Clears AG Grid selection/focus when clicking outside the grid container.
// Defaults: clears range selection and focused cell; keeps row selection.
export const useClearAgGridSelectionOnOutsideClick = (
  gridApiRef: MutableRefObject<GridApi | null>,
  {
    clearRange = true,
    clearFocus = true,
    containerSelector = '.wk-advanced-table-container',
  }: Options = {}
) => {
  useEffect(() => {
    const handler = (e: MouseEvent) => {
      const target = e.target as HTMLElement | null;
      const isInsideContainer = !!target?.closest(containerSelector);
      const isAgPopup = !!target?.closest('.ag-popup');
      const shouldClear = !!target && !isInsideContainer && !isAgPopup;

      if (shouldClear) {
        if (clearRange) {
          gridApiRef.current?.clearRangeSelection?.();
        }
        if (clearFocus) {
          gridApiRef.current?.clearFocusedCell?.();
        }
      }
    };

    document.addEventListener('mousedown', handler);
    return () => document.removeEventListener('mousedown', handler);
  }, [gridApiRef, clearRange, clearFocus, containerSelector]);
};

export default useClearAgGridSelectionOnOutsideClick;
